/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown>, metric: NonNullable<unknown>, days: NonNullable<unknown>, n: NonNullable<unknown> }} Perks_Trigger_StatInputs */



/**
* | output |
* | --- |
* | "{min} {metric} in {days} days" |
*
* @param {Perks_Trigger_StatInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_trigger_stat = /** @type {((inputs: Perks_Trigger_StatInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Trigger_StatInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") {
		const form = registry.plural("ru", i?.n, {}, true);
		if (form === "one") return /** @type {LocalizedString} */ (`${i?.min} ${i?.metric} за ${i?.days} день`);
		if (form === "few") return /** @type {LocalizedString} */ (`${i?.min} ${i?.metric} за ${i?.days} дня`);
		if (form === "many") return /** @type {LocalizedString} */ (`${i?.min} ${i?.metric} за ${i?.days} дней`);
		return /** @type {LocalizedString} */ (`${i?.min} ${i?.metric} за ${i?.days} дня`)
	}
	return /** @type {LocalizedString} */ (`${i?.min} ${i?.metric} in ${i?.days} days`)
});